import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const TroubleshootingPage = () => <Guide content={guides.troubleshooting} />
